// src/components/auth/ResetPassword.js
import React, { useState } from 'react';
import { useAuth } from '../../AuthContext';
import { Link } from 'react-router-dom';
import styles from './Auth.module.css';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const { resetPassword, error } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await resetPassword(email);
    setLoading(false);
    if (success) {
      setMessage('パスワードリセットのメールを送信しました。メールをご確認ください。');
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={styles.authCard}>
        <div className={styles.authHeader}>
          <h1 className={styles.authHeaderTitle}>BANNAI'S BAR</h1>
          <p className={styles.authSubtitle}>最高の一杯をあなたに</p>
        </div>
        
        <h2 className={styles.authTitle}>パスワードリセット</h2>
        
        {error && (
          <div className={styles.errorMessage}>
            {error}
          </div>
        )}
        
        {message && (
          <div className={styles.successMessage}>
            {message}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>
              メールアドレス
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={styles.formInput}
              placeholder="example@example.com"
              required
            />
            <small className={styles.formHelp}>
              登録したメールアドレスにリセットリンクを送信します
            </small>
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className={styles.formButton}
          >
            {loading ? '送信中...' : 'リセットリンクを送信'}
          </button>
        </form>
        
        <div className={styles.authLinks}>
          <Link to="/login" className={styles.authLink}>ログインへ戻る</Link>
        </div>
      </div>
    </div>
  );
};

export { ResetPassword };